import type { ConsentScope, PhotoRecord } from "./types";

export const canUsePhoto = (photo: PhotoRecord, scope: ConsentScope) =>
  photo.retouchStatus === "approved" && photo.consent[scope];

export const rightsLabel = (photo: PhotoRecord) => {
  if (photo.retouchStatus !== "approved") return "보정 승인 대기";
  const allowed = (Object.entries(photo.consent) as [ConsentScope, boolean][])
    .filter(([, value]) => value)
    .map(([scope]) => ({ social: "SNS", portfolio: "포트폴리오", commercial: "상업" })[scope]);
  return allowed.length > 0 ? `${allowed.join("·")} 사용 가능` : "공개 범위 없음";
};


export function updateConsent(photo: PhotoRecord, scope: ConsentScope, allowed: boolean, via: "self" | "reply" = "self", now = new Date()): PhotoRecord {
 return { ...photo, consent: { ...photo.consent, [scope]: allowed }, consentHistory: [...(photo.consentHistory || []), { at: now.toISOString(), scope, allowed, via }] };
}
export function applyConsentReply(photos: PhotoRecord[], requestId: string, consent: PhotoRecord["consent"], now = new Date()) {
 return photos.map(photo => {
   if (photo.consentRequestId !== requestId || photo.appliedConsentRequestId === requestId) return photo;
   let next = photo; for (const scope of ["social", "portfolio", "commercial"] as const) next = updateConsent(next, scope, consent[scope], "reply", now);
   return { ...next, appliedConsentRequestId: requestId };
 });
}
